<template>
  <div id="defaultId1" class="company_detail">
    <gui_card id="ge6845" class="uc1096 pb20" label="" :isShowLabel="false">
      <div>
        <h2 id="gf7b16" class="operations-head detail_title_20 ">
          <div>

            <span class="operations-headspan margin-right40" v-if="activeIEports == '1'">
              Top 10 Imports Products
            </span>
            <span class="operations-headspan  margin-right40" v-if="activeIEports == '2'">
              Top 10 Export Products
            </span>
            <el-date-picker style="width:  14.2857143rem;" v-model="Importyear" type="month" @change="ImportYear"
              value-format="yyyy-MM" placeholder="Please month">
            </el-date-picker>
            <!-- <el-select   v-model="Importyear" placeholder="Please Select" @change="ImportYear">
            <el-option v-for="item in Yearoptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select> -->
          </div>

          <div class="flex_between_box">

            <div class="perations-content-left margin-left20">
              <span :class="activeIEports == '1'
                ? 'perations-button perations-button-active'
                : 'perations-button'
                " @click="ceckIEports('1')"> Imports</span>
              <span @click="ceckIEports('2')" :class="activeIEports == '2'
                ? 'perations-button perations-button-active'
                : 'perations-button'
                ">Exports</span>
            </div>
          </div>
        </h2>

        <div class="flex_center_between_box">
          <div class="Products_lesft flex_center_between_box" style="height: auto; ">
                <ul class="img-center" :class="sourceImglist.length!=1?'img-center':'img-centerYear'">
                  <li v-for="(item,index) in sourceImglist " style="width: 20rem;min-width: 20rem;" :key="index"><span>{{ item[0] }} </span>
                  <i  class="el-icon-caret-right sanjiaoPostion" v-if="dataIndex==index"></i></li>
             
              </ul>
            <div ref="SupplyChainEchart" style="width: 98%; height: 100%"></div>
          </div>
          <div class="table-biao table-biao-left" style="position: relative;">
            <div class="flex_center_bettwen Country-protuct-table margin-bottom10">
              <div class="">
                <span class="Country-protuct-table-text">HS Code: </span>
                <span class="Country-protuct-table-text">{{ hsCode }}</span>
              </div>
              <div class="td-width-txt">
                <span class="Country-protuct-table-text">Products :</span>
                <el-tooltip class="tbl_opr_tip " :visible-arrow="false" effect="light"
                :content="hsCodeName" placement="top">
                <span style="cursor: pointer;" class="Country-protuct-table-text td-width-txt">{{ hsCodeName }}</span>
                </el-tooltip> 
              </div>
            </div>
            <el-table :data="ImporttableData" ref="table" empty-text="No Data" style="width: 100%" height="580"
              class="table_height_30 table_font_size_14 table_contentHeight_40">
              <el-table-column prop="date" label="Date" align="left" width="100" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span class="table-content">{{ scope.row.date }}</span>
                </template>
              </el-table-column>


              <el-table-column prop="MajorSuppliers" :label="activeIEports == '1'?'Major Suppliers':'Major Buyers'" align="left" width="280"
                show-overflow-tooltip>

                <template slot-scope="scope">
                  <span class="" style="color: #1290C9;cursor: pointer;" @click="setid(scope.row)">{{ scope.row.companyName }}</span>
                </template>
              </el-table-column>

              <!-- <el-table-column prop="products" label="Products" align="center"  show-overflow-tooltip>
                <template slot-scope="scope">
                    <span  style="color: #1290C9;cursor: pointer;">{{ scope.row.products }}</span>
                </template>
              </el-table-column> -->

              <el-table-column prop="originCountry" label=" Country" align="center"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <span style="cursor: pointer;" v-if="activeIEports == '1'">{{ scope.row.originCountry }}</span>
                  <span style="cursor: pointer;" v-else>{{ scope.row.destinationCountry }}</span>
                  <!-- </el-tooltip> -->
                </template>
              </el-table-column>
              <el-table-column prop="amount" label="Amount" align="center" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span>{{ scope.row.amount  | FilterNum  }}</span>
                  <!-- </el-tooltip> -->
                </template>
              </el-table-column>
            </el-table>

          </div>
        </div>

      </div>
    </gui_card>

    <ReLogin :reLoginPop="reLoginVis"></ReLogin>
  </div>

  <!--srcviewscompanydetailsBackgroundSnapshotvuehtmlEnd-->
</template>
<script>
// interfaceCode
//importStart
import {
  showProductsAggregationByCountry,
  showImportAndExportProductsOfTop10,
} from "@/api/companyApi";
import rectcard from "@/components/rectCard/index.vue";
import content_text from "@/components/text_content/index.vue";
import gui_card from "@/components/gui_card/gui_card.vue";
import ReLogin from "@/components/ReLogin.vue";
//importEnd
import { mixins1 } from "@/mixins/index";
export default {
  name: "",

  props: {},
  mixins: [mixins1],
  components: {
    // gui_card start
    gui_card,
    // gui_card end

    rectcard,
    content_text,
    ReLogin,
  },
  computed: {},
  mounted() {

    this.getNewsImportList()
    // this.getshowProductsAggregationByCountry()

  },
  data() {
    return {
      reLoginVis: false,
      Importyear: '2022-08',
      Exportyear: '2024',
      Yearoptions: [
        {
          label: '2025',
          value: '2025',
        },
        {
          label: '2024',
          value: '2024',
        },
        {
          label: '2023',
          value: '2023',
        },
        {
          label: '2022',
          value: '2022',
        },
        {
          label: '2021',
          value: '2021',
        },
        {
          label: '2020',
          value: '2020',
        },
        {
          label: '2019',
          value: '2019',
        },
        {
          label: '2018',
          value: '2018',
        },
        {
          label: '2017',
          value: '2017',
        },
        {
          label: '2016',
          value: '2016',
        },
        {
          label: '2015',
          value: '2015',
        },
        {
          label: '2014',
          value: '2014',
        },
        {
          label: '2013',
          value: '2013',
        },

      ],
      page: {
        pageNo: 1,
        pageSize: 5,
        total: 0,
      },
      sourceImglist:[],
      activeIEports: '1',
      activeIcon: 'computer1',
      keyNum: 0,
      SearchHscode: "",
      SelectHscode: '',
      hsCode: '',
      hsCodeName: '',
      dataIndex:0,
      ImporttableData: [],
      ExportTableData: [],
      importTopData: [],
      exportTopData: [],
      staticDataImport: [
      ],
      staticDataExport: [

      ],

      newDialog: false,
      // srcviewscompanydetailsBackgroundSnapshotvueDataEnd
    };
  },
  methods: {
       setid(row) {
        sessionStorage.setItem("company", JSON.stringify(row));
        let newscountry = JSON.parse(localStorage.getItem("countryList"))[0]?.countryList
          ;
        let SACode1 = "";
        newscountry.map((item) => {
          if (item.countryCode == row.company_country) {
            SACode1 = item.dowjonesCountrycode;
          }
        });
        let routeData = this.$router.resolve({
          // Tradecompany/Trade/
          // /company/detals
          path:
            "/index/company/detals/" +
            row.aaaId +
            "/background/snapshot?id3a=" +
            // "/tradeMap/map?id3a=" +
            row.aaaId +
            "&companyCountry=" +
            row.company_country +
            "&SACode1=" +
            SACode1 +
            "&companyName=" +
            row.companyName+
            '&keword='+this.$route.query.keword,
        });

        window.open(routeData.href, "_blank");

    },
    getshowProductsAggregationByCountry() {
      showProductsAggregationByCountry({
        country: 'US',
        tradeYearMonth: this.Importyear,
        importOrExportType: this.activeIEports,
        hsCode: this.hsCode
      }).then(res => {
        if (this.activeIEports == 1) {
          this.ImporttableData = res.data.importDetails
        } else {
          this.ImporttableData = res.data.exportDetails
        }
      })
    },
    ceckIEports(row) {
      this.activeIEports = row;
      this.getNewsImportList();
    },
    CheckClick(value) {
      this.activeIcon = value
      if (value == 'computer1') {
        // this.getexportData();

      }
    },
    ImportYear() {
      this.echartsBox = null
      this.getNewsImportList()

    },
    ExportYear() {
      this.getNewsExportList()

    },
    ImportsuppleEchart() {

      this.staticDataImport.map(item => {
        let countryImg = this.getCountryImgUrl(item[3]);
        item[3] = require("../../../../../static" + countryImg)

      })
      const startYear = this.Importyear; // 选择特定年份
      const source = this.staticDataImport.slice(1).filter(function (d) {
        return d[1] === startYear; // 过滤出特定年份的数据
      });
      source.sort((a, b) => b[2] - a[2]);
             this.sourceImglist=source
      //  console.log(`source`, source);
      this.echartsBox = this.$echarts.init(this.$refs.SupplyChainEchart);
      const option = {
        grid: {
          top: '5%',
          bottom: 30,
          left: 10,
          right: 25
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: function (params) {
            var tar = params[0];
            return tar.axisValueLabel + ' : ' + tar?.value?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') ;
          }
        },
        xAxis: {
          type: 'value',
          position: 'bottom', // 将 xAxis 放置在底部
          offset: 10, // 向下移动 10
          axisLabel: {
            show: true,
            color: '#1A2332', // 设置字体颜色
            fontSize: 14, // 可以在这里设置字体大小
            fontWeight: 'normal', // 字体粗细
            fontFamily: 'DMSans, DMSans',// 字体类型,
            formatter: function (value) {
              return value.length > 10 ? value.substring(0, 10) + '...' : value; // 超过10个字符则省略
            },
          },
          axisTick: { show: false }
        },

        yAxis: [{
          type: 'category',
          inverse: true,
          boundaryGap: false,
          axisLabel: {
            show: false,
            color: '#1A2332', // 设置字体颜色
            fontSize: 14, // 可以在这里设置字体大小
            fontWeight: 'normal', // 字体粗细
            fontFamily: 'DMSans, DMSans',// 字体类型,
            formatter: function (value) {

              return value.length > 10 ? value.substring(0, 10) + '...' : value; // 超过10个字符则省略
            },
          },
          data: source.map(item => item[0]), // 添加国家名称作为 x 轴数据
          // position: 'bottom',
          // offset: -10,
          axisLine: { show: false },
          axisTick: { show: false }
        },
        {
          type: 'category',
          inverse: true,
          boundaryGap: false,
          axisLabel: {
            show: false,
            fontSize: 14,
            textStyle: {
              color: '#1A2332', // 设置字体颜色
              fontSize: 14, // 可以在这里设置字体大小
              fontWeight: 'normal', // 字体粗细
              fontFamily: 'DMSans, DMSans' // 字体类型
            },

            formatter: function (value) {

              return value.length > 10 ? value.substring(0, 64) + '...' : value; // 超过10个字符则省略
            },
          },
          data: source.map(item => item[0]), // 添加国家名称作为 x 轴数据
          margin: 20, // 设置标签与坐标轴的间距
          zlevel: 4,
          nameLocation: 'start',
          axisLine: { show: false },
          axisTick: { show: false }
        },
        ],
        series: [
          {
            type: 'bar',
            barWidth: '25',
            showBackground: true,
            backgroundStyle: {
              color: 'rgba(180, 180, 180, 0.2)'
            },
            itemStyle: { color: '#009EA7' ,barBorderRadius: [0, 5, 5, 0]},
            emphasis: {
              itemStyle: { color: '#009EA7' }
            },
            label: {
              show: false,
              color: '#fff',
              z: 3,

              position: 'insideRight',
              //   formatter: '{c}%',
              formatter: function (params) {
                return (params['name'])
              }
            },
            data: source.map(item => item[2]) // 只保留值
          }
        ],


      };

      this.echartsBox.setOption(option);
      // params 里包含了当前点击的数据、系列等信息
      let that = this
      this.echartsBox.on('click', function (params) {
        that.hsCodeName = params.name
        that.dataIndex=params.dataIndex
        that.hsCode = that.importTopData.find(item => item.productName == params.name)?.hsCode
        that.getshowProductsAggregationByCountry()
      });
      // this.echartsBox.getZr().on("click", event=> {
      //   console.log(` event.topTarget.style`,  event);
      //         // 第三层文字点击事件
      //         // encodeURIComponent
      //         // let id = this.companyList.find(item => item.nameEn == event.topTarget.style.text)?.aaaId
      //         // let name = this.companyList.find(item => item.nameEn == event.topTarget.style.text)?.name

      //       })
      this.$nextTick(() => {
        this.echartsBox.resize();


      })
    },
    ExportsuppleEchart() {

      this.staticDataExport.map(item => {
        let countryImg = this.getCountryImgUrl(item[3]);
        item[3] = require("../../../../../static" + countryImg)

      })
      const startYear = this.Importyear; // 选择特定年份
      const source = this.staticDataExport.slice(1).filter(function (d) {
        return d[1] === startYear; // 过滤出特定年份的数据
      });
      source.sort((a, b) => b[2] - a[2]);
      this.echartsBox1 = this.$echarts.init(this.$refs.SupplyChainEchart1)

      const option1 = {
        grid: {
          top: '5%',
          bottom: 30,
          left: 10,
          right: 20
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: function (params) {
            var tar = params[0];
            return tar.axisValueLabel + ' : ' + tar?.value?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') ;
          }
        },
        xAxis: {
          type: 'value',
          position: 'bottom', // 将 xAxis 放置在底部
          offset: 10, // 向下移动 10
          axisLabel: {
            show: true,
            fontSize: 14,
            formatter: function (value) {

              return value.length > 10 ? value.substring(0, 10) + '...' : value; // 超过10个字符则省略
            },
          },
          axisTick: { show: false }
        },

        yAxis: {
          type: 'category',
          inverse: true,
          boundaryGap: false,
          axisLabel: {
            show: false,
            fontSize: 14,
            formatter: function (value) {

              return value.length > 10 ? value.substring(0, 10) + '...' : value; // 超过10个字符则省略
            },
          },
          data: source.map(item => item[0]), // 添加国家名称作为 x 轴数据
          // position: 'bottom',
          // offset: -10,
          axisLine: { show: false },
          axisTick: { show: false }
        },
        series: [
          {
            type: 'bar',
            barWidth: '25',
            showBackground: true,
            backgroundStyle: { color: '#F5F5F5' },
            itemStyle: { color: '#009EA7' },
            emphasis: {
              itemStyle: { color: '#009EA7' }
            },
            label: {
              show: true,
              color: '#fff',
              z: 3,

              position: 'insideRight',
              //   formatter: '{c}%',
              formatter: function (params) {
                return (params['name'])
              }
            },
            data: source.map(item => item[2]) // 只保留值
          }
        ],


      };
      this.echartsBox1.setOption(option1);
      this.$nextTick(() => {
        this.echartsBox1.resize();


      })
    },


    getNewsImportList() {
      showImportAndExportProductsOfTop10({
        country: this.$route.query.id3a,
        tradeYearMonth: this.Importyear,
        importOrExportType: this.activeIEports
      }).then(res => {
        console.log(`this.activeIEports `, this.activeIEports == 1);
        if (res.code == 200) {
          this.staticDataImport = []
          if (this.activeIEports == 1) {
            this.ImporttableData = res.data.importDetails
            this.importTopData = res.data.importTopData
            this.hsCodeName = res.data.importTopData[0].productName
            this.hsCode = res.data.importTopData[0].hsCode
            res.data.importTopData.map(item => {
              this.staticDataImport.push([
                item.productName,
                this.Importyear,
                item.transactions,
                'China'
              ])
            })
          } else {
            this.importTopData = res.data.exportTopData
            this.ImporttableData = res.data.exportDetails
            this.hsCodeName = res.data.exportTopData[0].productName
            this.hsCode = res.data.exportTopData[0].hsCode
            res.data.exportTopData.map(item => {
              this.staticDataImport.push([
                item.productName,
                this.Importyear,
                item.transactions,
                'China'
              ])
            })
          }

          let Countty = this.$route.query.id3a

          // this.staticDataImport = res.data
          this.staticDataImport.unshift(['Country', 'Year', 'Life Expectancy', 'CountryCode']),
            this.$nextTick(() => {
              this.ImportsuppleEchart()

            })
        }
      })
      // getfilterConditions()
    },


    ShowAll() {


    },
  },

};
</script>
<style scoped>
.uPdtqFl {
  padding-right: 2.857142857142857rem;
  padding-top: 2.142857142857143rem;
  padding-left: 2.857142857142857rem;
  padding-bottom: 2.142857142857143rem;
  box-shadow: 0rem 0.14285714285714285rem 1rem 0rem rgba(0, 0, 0, 0.12);
  background-color: #ffffff;
  border-top-left-radius: 0.2857142857142857rem;
  border-bottom-left-radius: 0.2857142857142857rem;
  border-top-right-radius: 0.2857142857142857rem;
  border-bottom-right-radius: 0.2857142857142857rem;
}

.importDetail-head {
  display: flex;
}

.head-titel {
  font-family: 'DMSans Bold';
  font-weight: 400;
  font-size: 1.857142857143rem;
  display: flex;
  align-items: center;
}

.table-biao {
  height: auto;
  overflow-y: auto;
  background: #ffffff;
  border-radius: 0.2857142857142857rem;
  margin-top: 1.4285714285714286rem;
}

.operations-head {
  font-size: 1.857142857143rem;

  font-family: 'DMSans Bold';
  color: #1a2332;
  text-align: left;
  font-style: normal;
  display: flex;
  justify-content: space-between;
}

.flex_center_between_box {
  display: flex;
  justify-content: space-between;
}

/deep/ .el-table .cell {
  color: #1a2332;
  font-family: 'DMSans Bold';
  padding-left: 1.4285714285714286rem !important;
}

/deep/ .highlight-cell {
  background-color: #f2f5f9 !important;
}

/deep/ .el-table th.el-table__cell {
  background-color: #f2f5f9 !important;
  font-family: 'DMSans Bold';
}

#cb02bf {
  padding-bottom: 1.4285714285714286rem;
}

.contclass {
  font-size: 1.4285714285714286rem;
  color: #1290c9;
  font-style: normal;
}

@media screen and (max-width: 1441px) {
  .contclass {
    font-size: 14px;

  }
}


.table_add {
  display: flex;
  justify-content: center;
  align-items: center;
}

.table_add_Text {
  font-family: 'DMSans Bold';
  text-align: left;
}

.table-content {
  font-size: 1.4285714285714286rem;
  color: #1a2332;
  display: inline-block;
  line-height: 2.142857142857143rem;
}

.uc1096 {
  height: 100%;
}

#cb02bf {
  padding-bottom: 1.4285714285714286rem;
}

.impact_status {
  width: 2.2857142857142856rem;
  height: 2.2857142857142856rem;
  text-align: center;
  border-radius: 50%;
}

.impact_status img {
  width: 1.1428571428571428rem;
  height: 1.1428571428571428rem;
  margin-top: 0.5rem;
}

.impact_status.green {
  background: #55b419;
}

.impact_status.hui {
  background: #ccc;
}

.impact_status.blue {
  background: #1290c9;
}

.impact_status.red {
  background: #ff7600;
}

.input-str {
  position: absolute;
  top: 0.2857142857142857rem;
  left: 13.214285714285714rem;
  z-index: 99;
  text-align: 7.142857142857143rem;
  width: 26%;
}

.input-str /deep/ .el-input__inner {
  margin-top: -0.14285714285714285rem;
}

/deep/.el-input__inner:focus {
  border: 0.07142857142857142rem solid #999999;
}

.uUIRzUi {
  padding: 2.142857142857143rem 2.857142857142857rem;
}

.Products_lesft {
  width: 60%;
  margin-right: 3rem;
  position: relative;
}

.table-biao {
  width: 40%;
}

.table-biao-left /deep/ .el-table td.el-table__cell {
  border-right: none;
  height: 3.71rem;
}

.Country-protuct-table {
  background: #F5F5F5;
  border-radius: 0px 4px 4px 0px;
  height: 3.71rem;
  padding: 0 1.4285714rem;
}

.Country-protuct-table-text {
  font-size: 1.285714rem;
  color: #009EA7;
  font-family: 'DMSans Bold' !important;
}

.td-width-txt {
  text-align: right;
  width: 70%;
  white-space: nowrap;
  /* 防止换行 */
  overflow: hidden;
  /* 隐藏超出部分 */
  text-overflow: ellipsis;
  /* 显示省略号 */
}
.sanjiaoPostion{
  position: absolute;
  right: 12px;
   font-size: 20px;
   color: #009EA7;
   margin-top: 5px;
}
</style>
